<template>
  <div class="general-settings-page">
    <CSPLoader v-if="loading" />
    <v-container v-else class="settings-container">
      <header class="settings-page-header">
        <v-btn icon class="settings-back" @click="$router.go(-1)"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <div>
          <small>Workplace preferences</small>
          <h1>General settings</h1>
          <p>Control how employees use the time clock at this location.</p>
        </div>
      </header>

      <section class="settings-section">
        <div class="settings-section__title">
          <span><v-icon>mdi-camera-outline</v-icon></span>
          <div><h2>Clock-in photos</h2><p>Photo capture and visibility options.</p></div>
        </div>
        <div class="setting-row">
          <div><strong>Save employee photos</strong><small>Capture a photo when employees clock in or out.</small></div>
          <v-switch v-model="metadata.customClockIn.storeTimeClockImage" color="accent" inset hide-details></v-switch>
        </div>
        <div v-if="metadata.customClockIn.storeTimeClockImage" class="setting-row">
          <div><strong>Show camera preview</strong><small>Let employees see the image being captured on the clock screen.</small></div>
          <v-switch v-model="metadata.customClockIn.storeTimeClockImageView" color="accent" inset hide-details></v-switch>
        </div>
      </section>

      <section class="settings-section">
        <div class="settings-section__title">
          <span><v-icon>mdi-account-group-outline</v-icon></span>
          <div><h2>Employee organization</h2><p>Choose how employees appear on the clock.</p></div>
        </div>
        <div class="setting-row">
          <div><strong>Group by department</strong><small>Display department headings on the employee time-clock screen.</small></div>
          <v-switch v-model="metadata.customClockIn.showDepartment" color="accent" inset hide-details></v-switch>
        </div>
      </section>

      <section class="settings-section">
        <div class="settings-section__title">
          <span><v-icon>mdi-clock-outline</v-icon></span>
          <div><h2>Hours & capacity</h2><p>Defaults used for attendance calculations.</p></div>
        </div>
        <div class="settings-fields">
          <v-text-field type="tel" v-model="metadata.customClockIn.defaultWorkingHours" outlined
            :error-messages="workingHoursError" label="Default work hours" hint="Used when an employee has no custom daily hours" persistent-hint></v-text-field>
          <v-text-field type="tel" v-model="metadata.customClockIn.allowedNumberOfClockedInEmployees" outlined
            :error-messages="allowedNumberOfClockedInEmployeesError" label="Simultaneous clock-in limit"
            hint="Maximum employees who may be clocked in at once" persistent-hint></v-text-field>
        </div>
      </section>

      <section class="settings-section">
        <div class="settings-section__title">
          <span><v-icon>mdi-earth</v-icon></span>
          <div><h2>Time zone</h2><p>Used for clock events and reporting at this location.</p></div>
        </div>
        <v-autocomplete class="timezone-field" v-model="selectedTimeZone" :items="timeZones" outlined
          label="Location time zone" prepend-inner-icon="mdi-map-clock-outline"></v-autocomplete>
      </section>

      <div class="settings-actions">
        <v-btn text large @click="$router.go(-1)">Cancel</v-btn>
        <v-btn color="primary" large rounded @click="update">
          <v-icon left>mdi-content-save-outline</v-icon>Save settings
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import settingService from "@/modules/Settings/service.js";
import authService from "@/modules/Authentication/service.js";
// import integrationService from "@/modules/Integration/service.js";
// import { mapGetters } from "vuex";
import locationService from "@/modules/Location/service.js";
const { validationMixin } = require("vuelidate");
const { integer, required } = require("vuelidate/lib/validators");

export default {
  data() {
    return {
      loading: true,
      timeZones: [],
      selectedTimeZone: null,
      locationCode: null,
      general: {},
      location: null,
      integration: null,
      metadata: {
        customClockIn: {
          storeTimeClockImage: false,
          showDepartment: false,
          defaultWorkingHours: 12,
          storeTimeClockImageView: false,
          // department: false,
          allowedNumberOfClockedInEmployees: 20
        },
      },
    };
  },
  created() {
    this.timeZones = this.$moment.tz.names();
    this.selectedTimeZone = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}timezone`)
    this.locationCode = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}code`
    );
    this.getLocation();
    this.getGeneral();
  },
  // computed: {
  //   ...mapGetters("global", ["getLocation"]),
  // },
  mixins: [validationMixin],
  validations: {
    metadata: {
      customClockIn: {
        defaultWorkingHours: {
          required,
          integer,
        },
        allowedNumberOfClockedInEmployees: {
          required,
          integer,
        },
      },
    },
  },
  computed: {
    allowedNumberOfClockedInEmployeesError() {
      const errors = [];
      if (!this.$v.metadata.customClockIn.allowedNumberOfClockedInEmployees.$dirty) return errors;
      if (!this.$v.metadata.customClockIn.allowedNumberOfClockedInEmployees.required) errors.push("Field Is Required");
      if (!this.$v.metadata.customClockIn.allowedNumberOfClockedInEmployees.integer)
        errors.push("Please enter number");
      return errors;
    },
    workingHoursError() {
      const errors = [];
      if (!this.$v.metadata.customClockIn.defaultWorkingHours.$dirty) return errors;
      if (!this.$v.metadata.customClockIn.defaultWorkingHours.required) errors.push("Field Is Required");
      if (!this.$v.metadata.customClockIn.defaultWorkingHours.integer)
        errors.push("Please enter number");
      return errors;
    },
  },
  methods: {
    getLocation() {
      this.loading = true;
      authService.getLocation(this.locationCode).then((response) => {
        // console.log("location", response);
        response.data.Integrations.map((row) => {
          if (row.pubSubHook === "TERMINALTIMECLOCK") {
            this.integration = row;
            console.log(row);
          }
        });
        if (response.data.metadata && response.data.metadata.customClockIn) {
          console.log("in custom close in ");
          this.metadata = {
            ...this.metadata,
            ...response.data.metadata,
          };
        } else {
          if (this.integration) {
            this.metadata = {
              ...this.metadata,
              ...this.integration.LocationIntegration.metadata,
            };
          }
        }
        this.location = response.data;
        this.loading = false;
      });
    },
    getGeneral() {
      this.loading = true;
      return settingService.getGeneral().then((response) => {
        console.log("response", response);
        this.general = response.data;
        this.loading = false;
      });
    },
    update() {
      this.$v.$touch();
      localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}timezone`, this.selectedTimeZone);
      this.$moment.tz.setDefault(this.selectedTimeZone);
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
        this.loadingBtn = false;
      } else {
        locationService.Terminal.update(this.location.id, {
          metadata: this.metadata,
        })
          .then((res) => {
            console.log("res", res);
            this.$toast.success("Setting was updated", { timeout: 2000 });
            this.$router.push({ name: "settings-index" });
          })
          .catch((err) => {
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 2000,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
.general-settings-page {
  color: var(--v-textPrimary-base);
}

.settings-container {
  height: calc(100vh - 132px);
  max-width: 860px;
  overflow: auto;
  padding: 24px 20px 160px;
}

.settings-page-header {
  align-items: flex-start;
  display: flex;
  gap: 13px;
  margin-bottom: 18px;
}

.settings-back {
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
}

.settings-page-header small {
  color: var(--v-textSecondary-base);
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.settings-page-header h1 {
  font-size: 1.7rem;
  line-height: 1.2;
  margin: 2px 0 4px;
}

.settings-page-header p,
.settings-section__title p {
  color: var(--v-textSecondary-base);
  margin: 0;
}

.settings-page-header p {
  font-size: 0.8rem;
}

.settings-section {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 18px;
  margin-bottom: 14px;
  padding: 18px;
}

.settings-section__title {
  align-items: center;
  display: flex;
  gap: 11px;
  margin-bottom: 12px;
}

.settings-section__title > span {
  align-items: center;
  background: rgba(96, 165, 250, 0.12);
  border-radius: 11px;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.settings-section__title .v-icon {
  color: var(--v-primary-base);
}

.settings-section__title h2 {
  font-size: 1rem;
  margin: 0;
}

.settings-section__title p,
.setting-row small {
  font-size: 0.7rem;
}

.setting-row {
  align-items: center;
  border-top: 1px solid var(--v-border-base);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  min-height: 68px;
  padding: 10px 2px;
}

.setting-row strong,
.setting-row small {
  display: block;
}

.setting-row strong {
  font-size: 0.84rem;
}

.setting-row small {
  color: var(--v-textSecondary-base);
  margin-top: 3px;
}

.settings-fields {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.settings-fields ::v-deep .v-input__slot,
.timezone-field ::v-deep .v-input__slot {
  background: var(--v-surfaceMuted-base) !important;
}

.settings-actions {
  align-items: center;
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 16px;
  bottom: 68px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 10px;
  left: 50%;
  max-width: 820px;
  position: fixed;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  z-index: 6;
}

@media (max-width: 600px) {
  .settings-container {
    height: calc(100vh - 122px);
    padding: 16px 12px 150px;
  }

  .settings-page-header h1 {
    font-size: 1.35rem;
  }

  .settings-section {
    border-radius: 15px;
    padding: 14px;
  }

  .settings-fields {
    grid-template-columns: 1fr;
  }

  .settings-actions {
    bottom: 68px;
    border-radius: 14px 14px 0 0;
    width: calc(100% - 24px);
  }
}
</style>
